import React from 'react';
import { InfoIcon } from 'lucide-react';
import { NewBadge } from './NewBadge';
import { ScopedNotification } from './ScopedNotification';
export function ParityBanner() {
  return <ScopedNotification tone="info" icon={InfoIcon} action={<NewBadge label="NEW" data-id="element-842" data-mp="1jkm9mdih65s2" />} data-id="element-841" data-mp="1jk2s2xwqljek">
      <strong data-id="element-843" data-mp="1oiw4en0af4d5">v1 parity = how Salesforce main calculates today.</strong> Anything tagged NEW is a proposed rebuild feature that does not exist today.
    </ScopedNotification>;
}